import builder from '../builder';
import RoadSignWarningAlternate from '../../streamline-icons/light/road-sign-warning-alternate.svg';

export default builder(
  'IconRoadSignWarningAlternateLight',
  RoadSignWarningAlternate,
);
